export default {
  init() {
    this.events();
  },

  events() {
    // Procurement on enter, search
    $(document).on('keyup', (e) => {
      if (
        e.key == 'Enter' &&
        $('.purchases__search input[name=search]').val()
      ) {
        $('.auction-filter').trigger('submit');
      }
    });

    $('.filter-button--open').on('click', () => {
      $('.filter').addClass('open');
    });
    $('.filter-button--close').on('click', () => {
      $('.filter').removeClass('open');
    });

    // Clear form
    $('.filter__clear').on('click', (e) => {
      e.preventDefault();
      const form = $(e.currentTarget).closest('.filter');
      window.location = form.attr('action');
    });

    // Handle form
    $('.filter').on('submit', (e) => {
      e.preventDefault();

      const form = $(e.currentTarget);

      this.handleFormSubmit(form);
    });
  },

  handleFormSubmit(form) {
    let params = {};

    // Search
    const search = $('.filter-search input');
    if (search.val()) {
      params.search = search.val();
    }

    // Year from
    const yearFrom = form.find('input[name=year-from]');
    if (yearFrom.val()) {
      params['year-from'] = yearFrom.val();
    }
    // Year to
    const yearTo = form.find('input[name=year-to]');
    if (yearTo.val()) {
      params['year-to'] = yearTo.val();
    }
    // Funding
    const funding = form.find('[name=funding]');
    if (funding.val()) {
      params['funding'] = funding.val();
    }
    // Type
    const type = form.find('[name=type]');
    if (type.val()) {
      params['type'] = type.val();
    }
    // Status
    const status = form.find('[name=status]');
    if (status.val()) {
      params['status'] = status.val();
    }

    // Create url
    let query = '';
    Object.keys(params).forEach((key, i) => {
      query += key + '=' + params[key];
      if (i < Object.keys(params).length) {
        query += '&';
      }
    });

    let url = form.attr('action');

    if (query) {
      window.location = url + '?' + query;
    } else {
      window.location = url;
    }
  },

  constructParams(fields) {
    let terms = [];
    fields.each((_i, field) => {
      field = $(field);
      if (field.val() && field.prop('checked')) {
        terms.push(field.val());
      }
    });

    return terms;
  },
};
